import { BASE_URL } from '../../config';
import React, { useState, useCallback, useEffect } from 'react';
import ImageViewer from 'react-simple-image-viewer';
import { MdImage, MdOutlineCancel, MdOutlinePictureAsPdf } from 'react-icons/md'



const GetTaskFile = (props: any) => {
    const [currentImage, setCurrentImage] = useState(0);
    const [isViewerOpen, setIsViewerOpen] = useState(false);
    const [imagesUrls, setImagesUrls] = useState();
    const { attachments, mode, removeHandler } = props;

    useEffect(() => {
        if (attachments.length > 0) {
            const modified = attachments.map((file: any) => {
                return `${BASE_URL}/task/get-file?hash=${file.fileHash}&token=${localStorage.getItem("token")}`
            })
            setImagesUrls(modified);
        }
    }, [attachments])


    const openImageViewer = useCallback((index) => {
        setCurrentImage(index);
        setIsViewerOpen(true);
    }, []);

    const closeImageViewer = () => {
        setCurrentImage(0);
        setIsViewerOpen(false);
    };
    return (
        <div className="d-flex flex-wrap align-items-center justify-content-center">
            {attachments.map((src, index) => (
                <div className="shadow-lg p-3 m-1 bg-white rounded m-2 " style={{ width: '130px', padding: '5px' }}>
                    <div className='d-flex align-items-center justify-content-between' style={{ cursor: mode === "Update" ? "pointer" : "" }}>
                        <img
                            src={`${BASE_URL}/task/get-file?hash=${src.fileHash}&token=${localStorage.getItem("token")}`}
                            onClick={() => openImageViewer(index)}
                            width="80px"
                            key={index}
                            style={{ margin: '2px' }}
                            alt=""
                        />


                        {isViewerOpen && (
                            <ImageViewer
                                src={imagesUrls}
                                currentIndex={currentImage}
                                disableScroll={false}
                                closeOnClickOutside={true}
                                onClose={closeImageViewer}
                            />
                        )}
                        <MdOutlineCancel onClick={() => removeHandler(src)} style={{ color: 'red', height: '20px', width: '20px', cursor: 'pointer', zIndex: '100px' }} title="Remove" />
                    </div>
                    <p style={{ fontSize: '13px', textAlign: 'start', margin: "4px 0 0 0" }}>{src.fileName.substring(0, 8) + '...'}</p>
                </div>
            ))}
        </div>
    );
}

export default GetTaskFile;
